























































import {Component, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import SpanNullable from "@/component/Span/span-nullable.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CompanyBookApi from "@/api/CompanyBookApi";
import {CompanyBookDetail} from "@/model/CompanyBook";
import companyBookModule from "@/store/module/CompanyBookModule";

@Component({
    components: {
        SpanNullable,
        RefreshButton,
    },
})
export default class BookInfoView extends Vue {

    @Inject
    private cbookApi!: CompanyBookApi

    private leftColSpan = 3
    private rightColSpan = 5

    private cbook = new CompanyBookDetail()

    private created() {
        this.getBookDetail()
    }

    private refresh() {
        this.getBookDetail()
    }

    private async getBookDetail() {
        const id = String(this.$route.query.id)
        this.cbook = await this.cbookApi.detail(id)
        await companyBookModule.activate(this.cbook)
    }
}
